<template>
  <div>
    <select
        :disabled="readOnly"
        :class="['role-selector-dropdown', readOnly ? 'read-only' : '']"
        v-model="role"
    >
      <option :key="index" v-for="(role, index) in possibleRoles" :value="role">{{ $t(role) }}</option>
    </select>
  </div>
</template>

<script>
import {UserRoles} from "@/enum";

export default {
name: "RoleSelector",
  props: {
    preSelectedRole: {type: String, default: 'viewer'},
    readOnly: {type: Boolean, default: false}
  },
  data() {
    return {
      possibleRoles: UserRoles,
      role: '',
    };
  },
  watch: {
    role() {
      this.$emit('update', this.role);
    }
  },
  beforeMount() {
    this.role = this.preSelectedRole;
  }
}
</script>

<style lang="scss" scoped>
.role-selector-dropdown {
  background-color: var(--vform-editor-ui-quinary-color);
  color: #fff;
  border-radius: 3px;
  border: none;
  padding: 1px;
  &.read-only {
    cursor: not-allowed;
    color: rgba(255,255,255,0.4);
  }
}
</style>